import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import PlacementDrives from './pages/PlacementDrives';
import DriveDetails from './pages/DriveDetails';
import VacancyDetails from './pages/VacancyDetails';
import About from './pages/About';
import Colleges from './pages/Colleges';
import CollegeDetails from './pages/CollegeDetails';
import Companies from './pages/Companies';
import CompanyVacancies from './pages/CompanyVacancies';
import Applications from './pages/Applications';
import Notifications from './pages/Notifications';
import Contact from './pages/Contact';
import Login from './pages/Login';
import StudentRegister from './pages/StudentRegister';
import CompanyRegister from './pages/CompanyRegister';
import AdminDashboard from './pages/admin/AdminDashboard';
import CompanyDashboard from './pages/company/CompanyDashboard';
import CoordinatorDashboard from './pages/coordinator/CoordinatorDashboard';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/admin/*" element={
            <ProtectedRoute requireAdmin={true}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/company-portal/*" element={
            <ProtectedRoute requireCompany={true}>
              <CompanyDashboard />
            </ProtectedRoute>
          } />
          <Route path="/coordinator-portal/*" element={
            <ProtectedRoute requireCoordinator={true}>
              <CoordinatorDashboard />
            </ProtectedRoute>
          } />
          <Route path="/*" element={
            <>
              <Navbar />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/placement-drives" element={<PlacementDrives />} />
                <Route path="/drive/:id" element={<DriveDetails />} />
                <Route path="/vacancy/:id" element={<VacancyDetails />} />
                <Route path="/about" element={<About />} />
                <Route path="/colleges" element={<Colleges />} />
                <Route path="/college/:id" element={<CollegeDetails />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/company/:id/jobs" element={<CompanyVacancies />} />
                <Route path="/applications" element={<Applications />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/login" element={<Login />} />
                <Route path="/student-register" element={<StudentRegister />} />
                <Route path="/company-register" element={<CompanyRegister />} />
              </Routes>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

